import styled from "styled-components"


const SwapEmptyInputSymbol = styled.div`
    color: ${({ theme }) => theme.emptyCurrencyTextColor};
    background-color: inherited;
    pointer-events: auto;
    src: $(props => props.src);
    font-size: 0.9em;
    margin: 0, auto;
    padding; 0.1em,
    test-align: center;
    align-self: center;
    display:flex;
    justify-content: center;
`;

export default SwapEmptyInputSymbol;

